module.exports = __webpack_public_path__ + "img/radar-bltr.f37a468e.webp";